import { render, staticRenderFns } from "./candidateFiles.vue?vue&type=template&id=62879db9&scoped=true"
import script from "./candidateFiles.vue?vue&type=script&lang=js"
export * from "./candidateFiles.vue?vue&type=script&lang=js"
import style0 from "./candidateFiles.vue?vue&type=style&index=0&id=62879db9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62879db9",
  null
  
)

export default component.exports